var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return !_vm.badge.inactive
    ? _c(
        "div",
        {
          staticClass:
            "user-profile-vanguard-badge ci-card ci-section text-center ci-content-padding",
        },
        [
          _c("h3", {
            staticClass: "h5 mb-0",
            domProps: {
              textContent: _vm._s(
                _vm.$t("ui.components.users.profile.vanguard_badge.title")
              ),
            },
          }),
          _c("div", { staticClass: "d-flex flex-column align-items-center" }, [
            _c("img", { attrs: { src: _vm.badge.image } }),
            _c("span", {
              staticClass: "text-center",
              domProps: {
                textContent: _vm._s(
                  _vm.$t(
                    "ui.components.users.profile.vanguard_badge.description"
                  )
                ),
              },
            }),
          ]),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }